export default __webpack_public_path__ + "static/media/82t.9b4aeb64.jpg";